'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPanoramaWideAngle = function MdPanoramaWideAngle(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 6.6q6 0 13.3 1.3l1.5 0.2 0.4 1.5q1.4 5.2 1.4 10.4t-1.4 10.4l-0.4 1.5-1.5 0.2q-7.3 1.3-13.3 1.3t-13.3-1.3l-1.5-0.2-0.4-1.5q-1.4-5.2-1.4-10.4t1.4-10.4l0.4-1.5 1.5-0.2q7.3-1.3 13.3-1.3z m0 3.4q-5.5 0-12.2 1.1-1.2 4.4-1.2 8.9t1.2 8.9q6.7 1.1 12.2 1.1t12.2-1.1q1.2-4.4 1.2-8.9t-1.2-8.9q-6.7-1.1-12.2-1.1z' })
        )
    );
};

exports.default = MdPanoramaWideAngle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/panorama-wide-angle.js
// module id = 3131
// module chunks = 0